"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.config.display.default.prompts.button': '¿No sabes qué preguntar? ¡Prueba nuestras sugerencias!',
    'chat.config.button.label.text': 'Enviar mensaje',
    'chat.config.cancel.button.label.text': 'Cancelar generación',
    'chat.config.voice.button.label.text': 'voice input',
    'chat.config.voice.rec.button.label.text': 'Escuchando entrada de voz',
    'chat.config.input.newline.helper': ' para nueva línea',
    'chat.config.autocomplete.styles.helper': ' para estilos',
    'chat.config.autocomplete.projects.helper': ' para proyectos',
    'chat.config.autocomplete.knowledge.helper': ' para conocimiento',
    'chat.config.live_chat.button.label.text': 'Live chat',
    'chat.config.input.placeholder': 'Escribe tu pregunta, ej., "¿Cómo puedo ayudarte?"',
    'chat.config.user.is.bot': 'Asistente de soporte',
    'chat.config.reset.button.label.text': 'X',
    'chat.config.reset.button.title.text': 'Restablecer pregunta actual',
    'chat.config.reset.chat.button.title': 'Restablecer chat',
    'chat.config.copy.response.button.label.text': 'Copiar respuesta',
    'chat.config.copied.successfully.message': '¡Respuesta copiada!',
    'chat.config.follow.up.questions.label.text': 'También puedes preguntar...',
    'chat.config.show.thought.process.button.label.text': 'Mostrar proceso de pensamiento',
    'chat.config.hide.thought.process.button.label.text': 'Ocultar proceso de pensamiento',
    'chat.config.loading.indicator.text': 'Por favor espera. Estamos buscando y generando una respuesta...',
    'chat.config.loading.text': 'Cargando...',
    'chat.config.api.error.message': 'Lo sentimos, tenemos algunos problemas. Por favor inténtalo de nuevo más tarde.',
    'chat.config.invalid.request.error': 'No se puede generar respuesta para esta consulta. Por favor modifica tu pregunta e inténtalo de nuevo.',
    'chat.config.thought.process.label': 'Proceso de pensamiento',
    'chat.config.support.context.label': 'Contexto de soporte',
    'chat.config.reasoning.label': 'Razonamiento',
    'chat.config.citations.label': 'Aprende más:',
    'chat.config.citations.tab.label': 'Citas',
    'chat.config.branding.logo.alt': 'Logo de marca',
    'chat.config.branding.headline': 'Bienvenido al asistente de soporte de nuestra marca',
    'chat.config.show.chat.history.label': 'Mostrar historial de chat',
    'chat.config.hide.chat.history.label': 'Ocultar historial de chat',
    'chat.config.chat.history.footer.text': 'Mostrando las últimas {MAX_CHAT_HISTORY} conversaciones',
    'chat.config.web.search.checkbox.label': 'Usar búsqueda web',
    'chat.config.deep.search.checkbox.label': 'Usar búsqueda profunda',
    'chat.config.adv.prompt.checkbox.label': 'Sugerencias avanzadas',
    'chat.config.autocomplete.style.selected': 'Estilo "{name}" ha sido añadido',
    'chat.config.autocomplete.project.selected': 'Proyecto "{name}" ha sido añadido',
    'chat.config.autocomplete.knowledge.selected': 'Conocimiento "{name}" ha sido añadido',
    'chat.config.add.kdb.button.label.text': 'Agregar a la base de conocimiento',
};
